<template>
  <div id="ad-training-details">
    <v-overlay :value="ProgressLoadingFlag">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Premium Header -->
    <div class="header-section">
      <div class="header-gradient">
        <v-row align="center" justify="space-between" class="pa-6">
          <v-col cols="12" md="8">
            <div class="d-flex align-center">
              <div class="header-icon-box">
                <v-icon size="32" color="white" class="mdi">mdi-briefcase-plus</v-icon>
              </div>
              <div class="ml-4">
                <h2 class="header-title white--text mb-0">{{ pageTitle }}</h2>
                <p class="header-subtitle white--text mb-0">Add your training details</p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="text-right">
            <v-btn icon small class="close-btn" @click="closePrompt">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>

    <v-card class="form-card">
      <v-form ref="form1" v-model="valid1" lazy-validation v-on:submit.prevent="submitForm">
        <v-card-text>
          <!-- Required Fields Note -->
          <v-card class="required-note-card mb-6" elevation="0">
            <v-row align="center" justify="center" class="pa-4">
              <v-col cols="auto" class="required-note-icon">
                <v-icon size="24">mdi-information-outline</v-icon>
              </v-col>
              <v-col cols="auto" class="required-note-label">
                <span>Fields marked with <span class="asterisk">*</span> are required</span>
              </v-col>
            </v-row>
          </v-card>

          <!-- Training Details Section -->
          <v-card class="section-card mb-6" elevation="0">
            <div class="section-title">
              <v-icon size="20" class="mr-2">mdi-briefcase-outline</v-icon>
              Training Information
            </div>
            <v-card-text class="pa-6">
              <div v-if="LoadingFlag" class="d-flex justify-content-center mb-3">
                <b-spinner variant="primary" type="grow" label="Loading..."></b-spinner>
              </div>
              <v-row wrap>
                <v-col cols="12" sm="6" lg="6" md="6">
                  <label class="field-label">
                    <span class="text-danger">*</span> Name of Training
                  </label>
                  <v-text-field v-model="Name" :rules="NameRules" outlined dense placeholder="e.g., Leadership Development" class="field-input"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" lg="6" md="6">
                  <label class="field-label">Training Date</label>
                  <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field required v-model="TrainingDate" label="Select date" readonly v-bind="attrs" v-on="on" outlined dense></v-text-field>
                    </template>
                    <v-date-picker v-model="TrainingDate" @input="menu1 = false"></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row wrap>
                <v-col cols="12" sm="6" lg="6" md="6">
                  <label class="field-label">
                    <span class="text-danger">*</span> Host Organization
                  </label>
                  <v-text-field v-model="Host" :rules="HostRules" outlined dense placeholder="e.g., JCI India" class="field-input"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" lg="6" md="6">
                  <label class="field-label">
                    <span class="text-danger">*</span> Pilot Faculty
                  </label>
                  <v-text-field v-model="PilotFaculty" :rules="PilotFacultyRules" outlined dense placeholder="Enter faculty name" class="field-input"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card-text>

        <!-- Action Buttons -->
        <v-row align="center" justify="center" class="button-section pa-6">
          <v-col cols="12" sm="6" lg="4" md="4" class="text-center">
            <v-btn @click.prevent="submitForm" :loading="submitFlag" color="success" elevation="0" rounded large class="action-btn save-btn" block>
              <v-icon left>mdi-check-circle</v-icon>Submit
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6" lg="4" md="4" class="text-center">
            <v-btn @click="closePrompt" color="error" elevation="0" rounded large class="action-btn close-btn" block>
              <v-icon left>mdi-close-circle</v-icon>Cancel
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    recordData: {
      required: true
    },
    pageTitle: {
      type: String
    }
  },
  data() {
    return {
      valid1: false,
      valid2: false,
      ProgressLoadingFlag: false,
      submitFlag: false,
      LoadingFlag: false,

      Name: "",
      NameRules: [v => !!v || "Name is required"],
      Host: "",
      HostRules: [v => !!v || "Host is required"],
      PilotFaculty: "",
      PilotFacultyRules: [v => !!v || "Pilot Faculty is required"],

      TrainingDate: new Date().toISOString().slice(0, 10),
      menu1: false
    };
  },
  computed: {},
  watch: {},
  created() {
    // this.initialize()
  },
  methods: {
    closePrompt(TrainingDetails = {}) {
      console.log("closePrompt called");
      console.log({ TrainingDetails });
      this.$emit("hideAddTrainingDetailsPrompt", TrainingDetails);
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.getTableRecords();
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form1.validate();
      if (validate1) {
        var TrainingDetails = {
          Name: this.Name,
          TrainingDetailsFlag: true,
          Date: this.TrainingDate,
          Host: this.Host,
          PilotFaculty: this.PilotFaculty,
          action: ""
        };
        this.$emit("hideAddTrainingDetailsPrompt", TrainingDetails);
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields";
        }
        // this.toast("error", message);
        this.sweetAlert("error", output, false);
      }
    }
  },
  beforeMount() {
    this.refreshPageData();
  }
};
</script>
<style lang="scss" scoped>
// Color Palette
$navy: #3A67B1;
$aqua: #0097D7;
$gold: #EDBE38;
$seaform: #56BDA3;
$text-90-black: #414042;
$text-off-black: #0A0F29;
$text-white: #FFFFFF;
$danger: #e74c3c;
$success: #1db954;
$info: #2196F3;

$primary-color: $navy;
$secondary-color: $aqua;
$bg-light: #f8fafc;
$border-color: #e2e8f0;

// Animations
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-12px);
  }
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

#ad-training-details {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px 0;
  min-height: 100vh;

  // ============================================
  // HEADER SECTION
  // ============================================
  .header-section {
    background: linear-gradient(135deg, $aqua 0%, $seaform 50%, $aqua 100%) !important;
    border-radius: 20px;
    overflow: hidden;
    position: relative;
    border: none;
    box-shadow: 0 20px 60px rgba(0, 151, 215, 0.5), 0 0 40px rgba(86, 189, 163, 0.3);
    margin: 15px !important;

    &::before {
      content: '';
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
      animation: rotate 20s linear infinite;
    }

    .header-gradient {
      position: relative;
      z-index: 1;
    }
  }

  .header-icon-box {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    border-radius: 16px;
    padding: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    animation: float 3s ease-in-out infinite;
  }

  .header-title {
    font-size: 28px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    animation: fadeInUp 0.8s ease-out;
  }

  .header-subtitle {
    font-size: 14px;
    opacity: 0.95;
    letter-spacing: 0.3px;
    animation: fadeInUp 1s ease-out;
  }

  .close-btn {
    background: rgba(255, 255, 255, 0.15) !important;
    backdrop-filter: blur(10px);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 2px solid rgba(255, 255, 255, 0.2);

    &:hover {
      background: rgba(255, 255, 255, 0.25) !important;
      transform: scale(1.1) rotate(90deg);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    }
  }

  // ============================================
  // FORM CARD
  // ============================================
  .form-card {
    border-radius: 18px !important;
    border: 2px solid rgba(58, 103, 177, 0.2);
    box-shadow: 0 12px 40px rgba(58, 103, 177, 0.15), 0 0 30px rgba(0, 151, 215, 0.08);
    animation: fadeInScale 0.6s ease-out;
    background: linear-gradient(to bottom, #ffffff 0%, #fafbff 50%, #f5f7ff 100%);
    position: relative;
    overflow: hidden;
    margin: 0 15px 20px 15px;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: radial-gradient(circle at 100% 0%, rgba(0, 151, 215, 0.1) 0%, transparent 50%);
      pointer-events: none;
    }
  }

  // ============================================
  // REQUIRED NOTE CARD
  // ============================================
  .required-note-card {
    border-radius: 12px !important;
    background: linear-gradient(135deg, rgba(58, 103, 177, 0.12) 0%, rgba(0, 151, 215, 0.08) 100%) !important;
    border-left: 5px solid $navy !important;
    animation: slideDown 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 0 8px 24px rgba(58, 103, 177, 0.15) !important;
    border: 2px solid rgba(58, 103, 177, 0.15) !important;
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 150px;
      height: 150px;
      background: radial-gradient(circle, rgba(0, 151, 215, 0.1) 0%, transparent 70%);
      pointer-events: none;
    }

    .required-note-icon {
      color: $navy !important;
      font-size: 24px;
      flex-shrink: 0;
    }

    .required-note-label {
      font-size: 14px;
      font-weight: 700;
      color: $navy;
      text-transform: uppercase;
      letter-spacing: 0.6px;

      .asterisk {
        color: $danger;
        font-weight: 900;
        margin: 0 4px;
      }
    }
  }

  // ============================================
  // SECTION CARD
  // ============================================
  .section-card {
    border-radius: 14px !important;
    border: 2px solid $border-color !important;
    box-shadow: 0 8px 24px rgba(58, 103, 177, 0.1) !important;
    animation: slideInUp 0.8s ease-out;
    background: linear-gradient(to bottom, #ffffff 0%, #fafbff 100%) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      box-shadow: 0 12px 32px rgba(58, 103, 177, 0.15) !important;
      border-color: rgba(58, 103, 177, 0.3) !important;
    }

    .section-title {
      font-size: 16px;
      font-weight: 700;
      color: $primary-color;
      display: flex;
      align-items: center;
      padding: 16px 20px !important;
      background: linear-gradient(135deg, rgba(58, 103, 177, 0.05) 0%, rgba(0, 151, 215, 0.05) 100%);
      border-radius: 12px 12px 0 0;
    }
  }

  // ============================================
  // FIELD STYLES
  // ============================================
  .field-label {
    display: block;
    font-size: 13px;
    font-weight: 700;
    color: $primary-color;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;

    .text-danger {
      color: $danger;
      font-weight: 900;
      margin-right: 4px;
    }

    small {
      font-weight: 500;
      font-size: 11px;
      color: $text-90-black;
      text-transform: lowercase;

      &.text-muted {
        color: #999;
      }
    }
  }

  .field-input {
    transition: all 0.3s ease;

    &:focus-within {
      box-shadow: 0 0 0 3px rgba(58, 103, 177, 0.1);
    }
  }

  // ============================================
  // BUTTON SECTION
  // ============================================
  .button-section {
    background: linear-gradient(135deg, rgba(58, 103, 177, 0.03) 0%, rgba(0, 151, 215, 0.03) 100%);
    border-top: 2px solid $border-color;
    margin: 0;

    .action-btn {
      min-width: 160px;
      border-radius: 10px !important;
      text-transform: uppercase;
      letter-spacing: 0.6px;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      font-size: 13px;
      font-weight: 700;

      &.close-btn {
        background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%) !important;
        color: white !important;

        &:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(231, 76, 60, 0.3);
        }
      }

      &.save-btn {
        background: linear-gradient(135deg, $seaform 0%, #4a9e8c 100%) !important;
        color: white !important;

        &:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(86, 189, 163, 0.3);
        }
      }

      &:disabled {
        opacity: 0.6;
        transform: none !important;
      }
    }
  }

  // ============================================
  // RESPONSIVE DESIGN
  // ============================================
  @media (max-width: 768px) {
    .header-section {
      margin: 10px !important;
    }

    .form-card {
      margin: 0 10px 20px 10px;
    }

    .header-title {
      font-size: 24px;
    }

    .header-subtitle {
      font-size: 13px;
    }

    .button-section {
      .action-btn {
        width: 100%;
        margin-bottom: 8px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>